import { render, staticRenderFns } from "./LocalUnitEditAddress.vue?vue&type=template&id=b70cb984"
import script from "./LocalUnitEditAddress.vue?vue&type=script&lang=ts"
export * from "./LocalUnitEditAddress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports